import axios from 'shared/lib/axios';
import { actions as aiAssistantActions } from 'store/AIAssistant';
import { store } from 'store/store';
import { getCustomerSupportTickets } from 'ux/Customer/Support/requests';

import { AIAssistantConversationAPI } from './types';

export async function fetchConversations(tenancyId: number) {
  const [{ data: conversationsResponse }, { data: supportTickets }] = await Promise.all([
    axios.get<AIAssistantConversationAPI[]>(`/v2/tenancies/${tenancyId}/ai_assistant_conversations`, {}),
    getCustomerSupportTickets()
  ]);
  store.dispatch(aiAssistantActions.setSupportTickets(supportTickets));
  return conversationsResponse;
}

export async function startConversation(tenancyId: number) {
  const conversationResponse = await axios.post<AIAssistantConversationAPI>(
    `/v2/tenancies/${tenancyId}/ai_assistant_conversations`,
    {}
  );
  return conversationResponse;
}

export async function postToConversation({
  tenancyId,
  conversationId,
  message
}: {
  tenancyId: number;
  conversationId: number;
  message: string;
}) {
  const conversationResponse = await axios.post<AIAssistantConversationAPI>(
    `/v2/tenancies/${tenancyId}/ai_assistant_conversations/${conversationId}/ai_assistant_messages`,
    {
      message
    }
  );
  const { data: supportTickets } = await getCustomerSupportTickets();
  store.dispatch(aiAssistantActions.setSupportTickets(supportTickets));
  return conversationResponse;
}

export async function addFeedbackToMessage(
  tenancyId: number,
  conversationId: number,
  messageId: number,
  liked: boolean
) {
  const payload = {
    liked
  };
  const response = await axios.post(
    `/v2/tenancies/${tenancyId}/ai_assistant_conversations/${conversationId}/ai_assistant_messages/${messageId}/feedback`,
    payload
  );
  return response;
}
